import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSMutation, WSMutationConfig } from "../../helpers";
import {
  QUERY_PAYMENTS_TAXFORM_LIST_PAYER,
  QUERY_PAYMENTS_TAXFORM_PAYER
} from "../keys";
import { paymentsService } from "../../../services/payments";
import { IPayerTaxFormResponse } from "@wingspanhq/payments/dist/interfaces";
import { QUERY_TAX_FORM_SUBMISSION_ROWS_SUMMARY } from "../../search/taxForm/queries/useQueryTaxFormSubmissionRowsSummary";
import { QUERY_TAX_FORM_SUBMISSION_ROWS } from "../../search/taxForm/queries/useQueryTaxFormSubmissionRows";

export const useMutationTaxFormResync = (
  config?: WSMutationConfig<IPayerTaxFormResponse, WSServiceError, string>
) =>
  useWSMutation(taxFormId => paymentsService.taxForm.resync(taxFormId), {
    dependencies: [
      QUERY_PAYMENTS_TAXFORM_PAYER,
      QUERY_PAYMENTS_TAXFORM_LIST_PAYER,
      QUERY_TAX_FORM_SUBMISSION_ROWS_SUMMARY,
      QUERY_TAX_FORM_SUBMISSION_ROWS
    ],
    ...config
  });
